import React from 'react';
import styled from 'styled-components';
import { X } from 'lucide-react';
import { LandingPageConfig } from '../types';
import LandingPageTemplate from './LandingPageTemplate';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 16px;
  width: 100%;
  max-width: 400px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3);
  position: relative;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  background: rgba(0, 0, 0, 0.1);
  border: none;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: background 0.2s;

  &:hover {
    background: rgba(0, 0, 0, 0.2);
  }
`;

const PreviewLabel = styled.div`
  position: absolute;
  top: 15px;
  left: 15px;
  background: rgba(102, 126, 234, 0.9);
  color: white;
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  z-index: 10;
`;

interface PreviewModalProps {
  config: LandingPageConfig;
  onClose: () => void;
}

const PreviewModal: React.FC<PreviewModalProps> = ({ config, onClose }) => {
  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <CloseButton onClick={onClose}>
          <X size={20} />
        </CloseButton>
        <PreviewLabel>PREVIEW</PreviewLabel>
        <div style={{ transform: 'scale(0.8)', transformOrigin: 'top center' }}>
          <LandingPageTemplate config={config} isPreview={true} />
        </div>
      </ModalContent>
    </ModalOverlay>
  );
};

export default PreviewModal;
